import React from 'react';
import { useLocation } from 'react-router-dom';
import Dashboard from './dashboard';

const DashboardLoader = () => {
    const location = useLocation();

    const extractDashboardId = (pathname) => {
        let output = 0;
        if (pathname.toString().includes('dashboard/')) {
            let params = pathname.split('/');
            if (!isNaN(params[params.length - 1])) {
                output = params[params.length - 1];
            }
        }
        return output;
    };

    const dashboardId = extractDashboardId(location.pathname);
    
    return (
        <React.Fragment>
            <Dashboard key={dashboardId} dashboardId={dashboardId} />
        </React.Fragment>
    );
};

export default DashboardLoader;
